import React from "react";

export default function ExcelIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="currentColor"
        d="M26 13a1 1 0 0 0-1-1H15a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1ZM26 19a1 1 0 0 0-1-1H15a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1ZM25 24a1 1 0 1 1 0 2H15a1 1 0 1 1 0-2h10Z"
      />
      <path
        fill="currentColor"
        d="M28 0a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h24ZM4 2a2 2 0 0 0-2 2v2h28V4a2 2 0 0 0-2-2H4ZM2 8v20a2 2 0 0 0 2 2h4V8H2Zm8 0v22h18a2 2 0 0 0 2-2V8H10Z"
      />
    </svg>
  );
}
